import { render } from "./LoginAuth.vue?vue&type=template&id=19133630"
import script from "./LoginAuth.vue?vue&type=script&lang=js"
export * from "./LoginAuth.vue?vue&type=script&lang=js"

import "./LoginAuth.vue?vue&type=style&index=0&id=19133630&lang=css"

import exportComponent from "/home/mitch/frontend/demoenv/demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__